import React, { useContext } from 'react';
import Select from 'react-select';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import { updateVulnFromAsset } from 'store/Contextualization/AssetDetail/actions';
import { selectDetail } from 'store/Contextualization/AssetDetail/selectors';
import { selectPermissions } from 'store/Manage/selectors';
import { statusSelect } from 'Common/styles/style';
import { capitalize } from 'utils/stringUtils';
import { status as statusList } from 'Screens/Constants';
import Wrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ActionBar/components/StatusPicker/styled';
import { selectReadOnly } from 'store/Faraday/selectors';
import { ThemeContext } from 'Context';

const StatusPicker = () => {
  const dispatch = useDispatch();
  const vuln = useSelector((state) => selectDetail('vulns', state));

  const readOnly = useSelector(selectReadOnly);
  const permissions = useSelector(selectPermissions);
  const status = get(vuln, 'status', '');
  const value = {
    label: capitalize(status),
    value: status
  };

  const { themeStyles, theme } = useContext(ThemeContext);
  const lightTheme = theme === 'light';

  return (
    <Wrapper isDisabled={ readOnly || !permissions?.update?.allowed }>
      <Select
        styles={ statusSelect(themeStyles, lightTheme) }
        isSearchable={ false }
        isDisabled={ readOnly || !permissions?.update?.allowed }
        value={ value }
        onChange={ (e) => dispatch(updateVulnFromAsset(vuln, 'status', e.value)) }
        options={ statusList.map((element) => ({ label: element.desc, value: element.name })) }
      />
    </Wrapper>
  );
};

export default StatusPicker;
